// WavyWaves shader aligned to WavyWavesBg visual
// Users can still override at runtime by registering with the same name
const frag = `
precision mediump float;

uniform vec2 u_resolution;
uniform float u_time;
uniform float u_speed;
uniform float u_expand;  // recommend ~6.0
uniform float u_scale;   // recommend ~5.0 - 15.0
uniform float u_seed;

uniform vec3 u_color_0;
uniform vec3 u_color_1;
uniform vec3 u_color_2;
uniform vec3 u_color_3;
uniform vec3 u_color_4;
uniform vec3 u_color_5;

varying vec2 vUv;

float f(in vec2 p)
{
    // incorporate speed and seed as phase offset
    float phase = u_time * u_speed + u_seed * 0.07;
    return sin(p.x + sin(p.y + phase)) * sin(p.y * p.x * 0.1 + phase);
}

vec2 field(in vec2 p)
{
    vec2 ep = vec2(.05, 0.);
    vec2 result = vec2(0.0);
    for (int i = 0; i < 7; i++) {
        // small seed-based offset to stabilize pattern per seed
        vec2 s = vec2(sin(u_seed * 0.013), cos(u_seed * 0.017)) * 0.01;
        float t0 = f(p + s);
        float t1 = f(p + ep.xy + s);
        float t2 = f(p + ep.yx + s);
        vec2 g = vec2((t1 - t0), (t2 - t0)) / ep.xx;
        vec2 t = vec2(-g.y, g.x);
        p += 0.9 * t + g * 0.3;
        result = t;
    }
    return result;
}

vec3 lut(float x) {
    if (x < 0.0 || x > 1.0) return u_color_0;

    float P1 = abs(x - 0.0);
    float P2 = abs(x - 0.167);
    float P3 = abs(x - 0.334);
    float P4 = abs(x - 0.500);
    float P5 = abs(x - 0.667);
    float P6 = abs(x - 0.833);
    float P7 = abs(x - 1.0);

    float R1 = smoothstep(1., -0.0, P1 * u_expand) / 1.;
    float R2 = smoothstep(1., -0.0, P2 * u_expand) / 1.;
    float R3 = smoothstep(1., -0.0, P3 * u_expand) / 1.;
    float R4 = smoothstep(1., -0.0, P4 * u_expand) / 1.;
    float R5 = smoothstep(1., -0.0, P5 * u_expand) / 1.;
    float R6 = smoothstep(1., -0.0, P6 * u_expand) / 1.;
    float R7 = smoothstep(1., -0.0, P7 * u_expand) / 1.;

    vec3 color = u_color_0 * R1 +
                 u_color_1 * R2 +
                 u_color_2 * R3 +
                 u_color_3 * R4 +
                 u_color_4 * R5 +
                 u_color_5 * R6 +
                 u_color_0 * R7;
    return color;
}

void main() {
    vec2 p = gl_FragCoord.xy / u_resolution.xy - 0.5;
    p.x *= u_resolution.x / u_resolution.x; // keep square mapping like WavyWavesBg
    p *= u_scale;

    vec2 fld = field(p);
    float factor = (1.0 - fld.y) * (0.5 - fld.x);
    vec3 col = lut(factor);
    gl_FragColor = vec4(col, 1.0);
}
`;

const shader = {
  name: 'WavyWaves',
  shader: {
    frag,
  },
  schema: [
    {
      key: 'colors',
      type: 'color-palette',
      label: 'Colors',
      min: 2,
      max: 6,
      default: ['#00ffff', '#2575fc', '#ffffff'],
    },
    {
      key: 'u_expand',
      type: 'number',
      label: 'Expand',
      min: 0.5,
      max: 20,
      step: 0.5,
      default: 6,
    },
    { key: 'u_scale', type: 'number', label: 'Scale', min: 1, max: 30, step: 0.5, default: 10 },
    { key: 'speed', type: 'number', label: 'Speed', min: 0, max: 10, step: 0.1, default: 1 },
    { key: 'animated', type: 'boolean', label: 'Animated', default: false },
  ],
  examples: [
    'dynamic-shader(WavyWaves, colors=#0ff,#2575fc,#ffffff; u_expand=6; u_scale=10; animated=false)',
    'dynamic-shader(WavyWaves, colors=#4facfe,#00f2fe,#222; u_expand=8; u_scale=14; animated=false)',
    'dynamic-shader(WavyWaves, colors=#fbc2eb,#a6c1ee; u_expand=5; u_scale=9; animated=false)',
  ],
};

export default shader;
